import React from "react";
//#region redux
import { useDispatch } from "react-redux";
import { ThunkDispatch } from "redux-thunk";
import { displayDialog } from "store/actions/utilActions";
//#endregion
//#region types
import { SelectionItem, SelectionResponse } from "models/utilTypes/selectionTypes";
import { DialogEnums } from "models/enums";
import { IconDefinitionConstants } from "utils/constants";
import { SuggestionProps } from "models/propTypes/wintFormPropsTypes";
//#endregion
//#region components
import Icon from "../../icon";
import RoundButton from "../../buttons/roundButton";
import StyledButton from "../../buttons/styledButton";
import AutoGeneratedMessage from "../../messages/autoGeneratedMessage";
import { Chip, Grid } from "@mui/material";
//#endregion
import cssExports from "theme/styles/main.module.scss";
import { LocalizationHelperInstance } from "utils/helpers";
import clsx from "clsx";

const Suggestions: React.FC<SuggestionProps> = (props) => {
  const dispatch: ThunkDispatch<any, any, any> = useDispatch();

  const onSuggestionSelect = (selectedItem: SelectionItem, e: React.MouseEvent<HTMLDivElement>) => {
    props.setValue(selectedItem);
    props.setTouched && props.setTouched(true, false);
  };

  const defaultSuggestionsCount = 3;

  const onDisplayDialog = () => {
    props.form &&
      dispatch(
        displayDialog({
          isOpen: false,
          title: props.form.title,
          subTitle: props.form.subTitle,
          titleIcon: props.form.titleIcon,
          dialogType: DialogEnums.DialogType.Content,
          actions: [
            {
              text: LocalizationHelperInstance.getFormattedMessage("Common.SaveChanges"),
            },
          ],
          fullWidth: true,
          children: props.form.form,
          onSubmit: onFormSubmit,
        })
      );
  };

  const onFormSubmit = (values?: any) => {
    const response = values as SelectionResponse;
    props.onFormSubmit && props.onFormSubmit(response);
  };

  const onAddButtonClick = () => {
    if (props.onAddButtonClick) props.onAddButtonClick!();
    else if (props.form) onDisplayDialog();
  };

  return (
    <Grid
      item
      container
      className={clsx(cssExports.suggestionsChips, cssExports.selectionChipsGroup, props.className)}
      spacing={1}
      data-testid={`suggestionsChips`}
    >
      <Grid item container className={cssExports.selectionChips} spacing={1} direction="row">
        {props.suggestions.slice(0, props.maxSuggestionsCount ?? defaultSuggestionsCount).map((item) => (
          <Grid item key={item.id}>
            <Chip
              className={clsx(cssExports.chip)}
              variant="outlined"
              data-key={item.id}
              label={item.value}
              clickable
              onClick={onSuggestionSelect.bind(null, item)}
            />
          </Grid>
        ))}
        {(props.onAddButtonClick || props.form) && (
          <Grid item>
            {props.addButtonLabel ? (
              <StyledButton size="xs" onClick={onAddButtonClick}>
                {props.addButtonLabel}
              </StyledButton>
            ) : (
              <RoundButton size="sm" onClick={onAddButtonClick}>
                <Icon icon={IconDefinitionConstants.WPlus} />
              </RoundButton>
            )}
          </Grid>
        )}
      </Grid>
      {props.autogeneratedText && props.suggestions && props.suggestions.length > 0 && (
        <Grid item container>
          <AutoGeneratedMessage className={cssExports.suggestionsChipsAutogeneratedMessage}>
            {props.autogeneratedText}
          </AutoGeneratedMessage>
        </Grid>
      )}
    </Grid>
  );
};

export default Suggestions;
